import React, { useRef } from 'react';
import { SnackbarProvider } from 'notistack';
import { CloseRounded } from '@material-ui/icons';
import { UnstyledButton } from '~/components/buttons/';

export const CustomSnackbarProvider: React.FC = ({ children }): JSX.Element => {
  const myRef = useRef(null);

  return (
    <SnackbarProvider
      maxSnack={2}
      ref={myRef}
      hideIconVariant={true}
      action={snackbarId => (
        <UnstyledButton onClick={() => myRef.current.closeSnackbar(snackbarId)}>
          <CloseRounded />
        </UnstyledButton>
      )}
    >
      {children}
    </SnackbarProvider>
  );
};
